import vueDebounce from 'vue-debounce'
import Vue from 'vue'

Vue.use(vueDebounce)